// Charge la base commune
import './common.js'

// Scripts librairies
import { dtectMap } from './js/libs/utils'

// Styles custom
import './scss/pages/offersAll.scss'

// Offers map
async function getOffersMap ($f) {
  $f.load()
  import(/* webpackChunkName: "offersMap", webpackPrefetch: true */ './js/components/offersMap.js').then(() => {
    /* global Waypoint */
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// Offers Filter Form
async function getOfForm ($f) {
  $f.load()
  import(/* webpackChunkName: "offersFilterForm", webpackPrefetch: true */ './js/components/offersFilterForm.js').then(() => {
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// Offers Autocomplete
async function getOffersAutocomplete ($f) {
  import(/* webpackChunkName: "offersAutocomplete" */ './js/components/offersAutocomplete.js').then(module => {
    module.offersAutocomplete.init($f)
  })
}

// Offers Alert Form
async function getOaForm ($f) {
  $f.load()
  import(/* webpackChunkName: "offersAlertForm" */ './js/components/offersAlertForm.js').then(() => {
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// Custom Lists
async function getCustomLists () {
  import(/* webpackChunkName: "customLists" */ './js/components/customLists.js').then(() => {
    Waypoint.refreshAll()
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // à exécuter une fois la GMap API correctement chargée
  dtectMap(function () {
    // gestion de la carte des offres
    const $c1 = $('#map-offers')
    if ($c1.length) {
      $c1.waypoint(function () {
        getOffersMap($c1)
        this.destroy()
      }, {
        offset: '100%'
      })
    }
  })

  // gestion des filtres des offres
  const $c2 = $('form[name="ofForm"]')
  if ($c2.length) {
    $c2.waypoint(function () {
      getOfForm($c2)
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // filtres des offres autocomplete
  $('form[name="ofForm"] input[name="location"]').on('click keyup focus', function () {
    $(this).blur().off().attr('disabled', '').val('Veuillez patienter...')
    getOffersAutocomplete($(this).parents('form'))
  })

  const $go = $('#go')
  if ($go.length) {
    const h = $('#header').height()
    const p = $('#sub-nav').height()
    $('html').animate({ scrollTop: $go.offset().top - h - p - 40 }, { duration: 300, easing: 'linear' }, function () {
      $('html').animate({ scrollTop: $go.offset().top - h - p - 40 }, { duration: 300, easing: 'linear' })
    })
  }

  // ancre
  $.each($('.scroll'), function (i, elem) {
    $(elem).off().on('click', function (e) {
      const t = ($(e.target).is('a')) ? this.hash : $(this).attr('target')
      e.preventDefault()
      if ($(t).length > 0) {
        const h = $('#header').height()
        const p = $('#sub-nav').height()
        $('html').animate({ scrollTop: $(t).offset().top - h - p - 10 }, { duration: 300, easing: 'linear' }, function () {
          $('html').animate({ scrollTop: $(t).offset().top - h - p - 10 }, { duration: 300, easing: 'linear' })
        })
      }
    })
  })

  // formulaire d'inscription aux alertes terrains/offres
  const $c3 = $('form[name="oaForm"]')
  if ($c3.length) {
    $c3.waypoint(function () {
      getOaForm($c3)
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion des scrollbars améliorées
  const $c4 = $('.custom-lists')
  if ($c4.length) {
    $c4.waypoint(function () {
      getCustomLists()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion des alertes BS
  const $c5 = $('.alert')
  if ($c5.length) {
    $c5.waypoint(function () {
      import(/* webpackChunkName: "alertBs" */ './scss/components/alertBs.scss').then(() => {
        Waypoint.refreshAll()
      })
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion des filtres depuis la navbar
  const $mn = $('#sub-nav')
  const $h = $('#header')
  $h.find('.navbar-toggler, .navbar-close').on('click', function () {
    if ($h.find('.navbar-collapse').hasClass('show')) { $mn.parents('.sticky-top').css('z-index', '999') } else { $mn.parents('.sticky-top').css('z-index', '1020') }
  })
  $mn.find('.navbar-toggler, .navbar-close').on('click', function () {
    if ($mn.find('.navbar-collapse').hasClass('show')) { $mn.parents('.sticky-top').css('z-index', '1020') } else { $mn.parents('.sticky-top').css('z-index', '999') }
  })
})
